import React, { useState, useEffect } from "react";
import moment from "moment";
import styled from "styled-components";
import Button from "../Button";
import TestingCategory from "../common/form/TestingCategory";
import DateFilter from "../common/form/DateFilter";
import CompanyFilter from "../common/form/CompanyFilter";
import CompanyBranchFilter from "../common/form/CompanyBranchFilter";
import ReceivedStatus from "../common/form/ReceivedStatus";
import { Row, Column, FullColumn } from "../common/layout/Grid";

const Container = styled.div.attrs({
  className: "form-panel with-padding",
})``;

export default function ContractReviewSearchForm({ onSubmit, laboratory_company_id }) {
  const [loading, setLoading] = useState(false);
  const [testingCategory, setTestingCategory] = useState(null);
  const [startDate, setStartDate] = useState(moment().subtract(10, "days"));
  const [endDate, setEndDate] = useState(moment());
  const [dateFilter, setDateFilter] = useState("registered");
  const [companyId, setCompanyId] = useState(null);
  const [companyBranchId, setCompanyBranchId] = useState(null);
  const [requireContractReview, setRequireContractReview] = useState(true);
  const [receivedStatus, setReceivedStatus] = useState("received");
  const [receivedByLabBranchId, setReceivedByLabBranchId] = useState(null);
  const [withoutPrepaymentAuthorisation, setWithoutPrepaymentAuthorisation] = useState(false);

  const handleSubmit = () =>
    onSubmit({
      testingCategory,
      start_date: startDate,
      end_date: endDate,
      dateFilter,
      company_id: companyId,
      company_branch_id: companyBranchId,
      require_contract_review: requireContractReview,
      received: receivedStatus,
      received_by_company_branch_id: receivedByLabBranchId,
      without_prepayment_authorisation: withoutPrepaymentAuthorisation,
    });

  const canSubmit = () => true;

  return (
    <Container>
      <Row>
        <FullColumn>
          <div className="alert alert-default" style={{ marginBottom: 0 }}>
            Samples must be contract reviewed before they can be scheduled into the lab (which
            allows label printing, results entry etc)
          </div>
        </FullColumn>
      </Row>
      <Row>
        <Column>
          <TestingCategory
            value={testingCategory}
            onChange={(val) => setTestingCategory(val)}
          />
        </Column>
        <Column>
          <DateFilter
            clientView={false}
            setDateFilter={(dateFilter) => setDateFilter(dateFilter)}
            dateFilter={dateFilter}
            start_date={startDate}
            end_date={endDate}
            onDatesChange={({ start_date, end_date }) => {
              setStartDate(start_date);
              setEndDate(end_date);
            }}
            only={[
              "registered",
              "requested_test_date",
              "contract_review_date",
              "first_received_by_lab_date",
              "received_by_specific_lab",
            ]}
          />
        </Column>
        {dateFilter === "received_by_specific_lab" && (
          <Column>
            <CompanyBranchFilter
              company_id={laboratory_company_id}
              company_branch_id={receivedByLabBranchId}
              onChange={(branch) => setReceivedByLabBranchId(branch ? branch.id : null)}
              title="Select Branch it was received by"
            />
          </Column>
        )}
      </Row>
      <Row>
        <Column>
          <CompanyFilter
            company_id={companyId}
            onChange={(companyId) => {
              setCompanyId(companyId);
              setCompanyBranchId(null);
            }}
          />
        </Column>
        {companyId && (
          <Column>
            <CompanyBranchFilter
              company_id={companyId}
              company_branch_id={companyBranchId}
              onChange={(branch) => setCompanyBranchId(branch ? branch.id : null)}
            />
          </Column>
        )}
        <Column>
          <ReceivedStatus
            onChange={(value) => setReceivedStatus(value)}
            value={receivedStatus}
          />
        </Column>
      </Row>
      <Row>
        <Column>
          <label>
            <input
              type="checkbox"
              checked={requireContractReview}
              onChange={() => setRequireContractReview(!requireContractReview)}
            />
            &nbsp; Requires Contract Review?
          </label>
        </Column>
        <Column>
          <label>
            <input
              type="checkbox"
              checked={withoutPrepaymentAuthorisation}
              onChange={() =>
                setWithoutPrepaymentAuthorisation(!withoutPrepaymentAuthorisation)
              }
            />
            &nbsp; Exclude samples where prepayment authorisation is required but not given?
          </label>
        </Column>
      </Row>
      <Row style={{ paddingBottom: 0, paddingTop: 5 }}>
        <Column>
          <Button
            disabled={!canSubmit()}
            title={loading ? I18n.t("loading") : I18n.t("search")}
            icon="fa-search"
            onClick={handleSubmit}
          />
        </Column>
      </Row>
    </Container>
  );
}
